import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const classDeleteApi = createAsyncThunk(
    'auth/class/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.classesAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const classDeleteSlice = createSlice({
    name: 'class delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(classDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(classDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(classDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const classDeleteReducer = classDeleteSlice.reducer